import styled, { css } from 'styled-components'

import { MenuContentStyles } from '../Menu'
import Popover from '../Popover/Popover'

const quickPickButtonStyles = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: solid 1px transparent;
  border-radius: 4px;
  padding: 2px 6px;
  font-family: inherit;
  font-size: 14px;
  color: inherit;
  cursor: pointer;
  transition:
    background-color 120ms ease,
    border-color 120ms ease;

  &:hover:not(:disabled) {
    background-color: var(--color-primary-bg);
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 2px var(--color-primary-focus-ring);
  }

  &:disabled {
    color: var(--color-neutral-400);
    cursor: not-allowed;
  }
`

export const DatePickerPopoverContent = styled(Popover.Content)`
  ${MenuContentStyles};
  padding-bottom: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  // Lock to a fixed width so the popover doesn't resize between views.
  // Binding constraint is the day grid (240px) + padding. 288px keeps the
  // component compact now that month labels are 3-letter abbreviations.
  width: 288px;
`

export const CalendarHeaderNavButton = styled.button`
  ${quickPickButtonStyles};
  width: 24px;
  height: 24px;
  padding: 0;
`

export const CalendarHeaderLabelButton = styled.button`
  ${quickPickButtonStyles};
  font-weight: 500;
`

export type QuickPickCellState = 'default' | 'selected' | 'today'

export const QuickPickCell = styled.button<{ $state: QuickPickCellState }>`
  ${quickPickButtonStyles};
  height: 40px;
  font-weight: 500;

  ${(p) =>
    p.$state === 'selected' &&
    css`
      background-color: var(--color-primary);
      color: white;

      &:hover:not(:disabled) {
        background-color: var(--color-primary);
      }
    `}

  ${(p) =>
    p.$state === 'today' &&
    css`
      border-color: var(--color-primary);
    `}
`
